export default {
    active:   'active',
    finished: 'finished',
    sketch:   'sketch',
};
